import NotesComponent from "../notes/NotesComponent"
import TabHeader from "../../tab/TabHeader"
import TransportationControls from "./TransportationControls"
import TransportationDetails from "./TransportationDetails"

const Transportation = ({inWorkQ}) => {

    return <>
        <TabHeader>
            {!inWorkQ && <div className="flex-container">
                <h2>Transportation</h2>
                <NotesComponent  noteTypeId={9}/>                
            </div>}
            {inWorkQ && <div className="flex-container">
                
            </div>}
       
            <TransportationControls inWorkQ={inWorkQ} />
            {/* {patientHasCompleteAddress(activeCase?.patient?.contact_information) && <TransportationControls />} */}
        </TabHeader>
        <div>
            <TransportationDetails inWorkQ={inWorkQ}/>
            {/* {patientHasCompleteAddress(activeCase?.patient?.contact_information) && <TransportationDetails />}

            
            {!patientHasCompleteAddress(activeCase?.patient?.contact_information) && <TabHidden>
                <p>Patient Address is incomplete</p>    
            </TabHidden>} */}
        </div>
    </>
}

export default Transportation